import {queryToString} from '@wix/wixstores-client-storefront-sdk/dist/src/services/utils';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import {Experiments} from '../constants';

export enum WarmUpDataRequestType {
  PRODUCTS = 'products',
  INITIAL_DATA = 'initialData',
  OLD_INITIAL_DATA = 'oldInitialData',
  CATEGORY_INITIAL_DATA = 'categoryInitialData',
  FILTERS = 'filters',
}

export function isWarmUpDataEnabled(siteStore: SiteStore): boolean {
  return siteStore.experiments.enabled(Experiments.EnableWarmUpDataCaching);
}

export function generateCacheKeySuffix(
  query: Record<string, any>,
  mainCollectionId: string | null,
  compId: string
): string {
  const collection = mainCollectionId || 'default';
  const componentId = compId;
  const urlParams = queryToString(query) || 'default';
  return `${collection}_${componentId}_${urlParams}`;
}

export function createWarmUpDataKey(requestType: WarmUpDataRequestType, suffix: string): string {
  return `${requestType}_${suffix}`;
}
